import { createSlice } from '@reduxjs/toolkit';
import { productPropPrecedenceEdit } from './productPropAsyncThunk';

const productPropPrecedenceEditSlice = createSlice({
  name: "productProp",
  initialState: {
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [productPropPrecedenceEdit.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [productPropPrecedenceEdit.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
    },
    [productPropPrecedenceEdit.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default productPropPrecedenceEditSlice.reducer;